export const GEN_AND_SELECT_SETTINGS = 'genAndSelect';
export const COLLAB_MODE_INTERACTIONS_TRACKING = 'collaborationModeInteractions';

// Duplicates of types from content-assistance-lib to prevent runtimeDep proliferation

// End type duplication from content-assistance-lib

// Cannot directly refer to these types in copilot-toolkit, since it would bring a cascade of runtimeDeps

// @temporary Remove string type once all consumers have been updated
// @expiration 2025-04-15
// @deprecated
// Optionally needed for content editor (i.e. crazy iframe apps) to pass useCollaborationSession functions
// from React tree to tinymce plugin. But not needed for typical hscopilotcollaboration consumers.